import React from 'react';
import { Box } from '@mui/material';
import { CurrencyInputField } from 'components/form';
import { FieldPath, useFormContext } from 'react-hook-form';
import { ListingForm } from 'components/shared/TableListing/types';
import { Charge } from '../../../types';

interface Props {
  index: number;
  type: keyof Charge;
}

export const ChargeValueCell = ({ index, type }: Props) => {
  const inputName = `bodyFields.${index}.${type}` as FieldPath<ListingForm<Charge>>;

  const { control } = useFormContext<ListingForm<Charge>>();

  return (
    <Box>
      <CurrencyInputField allowNegative name={inputName} control={control} textFieldProps={{ variant: 'outlined' }} />
    </Box>
  );
};
